"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAdjustedItemCountByLimit = void 0;
const getAdjustedItemCountByLimit = (nbItems = 0, limit = 0) => limit && nbItems > limit ? limit : nbItems;
exports.getAdjustedItemCountByLimit = getAdjustedItemCountByLimit;
//# sourceMappingURL=getAdjustedItemCountByLimit.js.map